import { z } from "zod";
const HashSchema = z.string().regex(/^sha256:[a-f0-9]{64}$/);
export const ClinicDocumentFillSuggestionsCommandSchema = z.strictObject({
    tenantId: z.uuid(),
    siteId: z.uuid(),
    selectionId: z.uuid(),
    expectedSelectionHash: HashSchema,
    documentId: z.uuid(),
    documentVersion: z.number().int().positive(),
    expectedDocumentHash: HashSchema,
    expectedSourceContextHash: HashSchema,
    excludedFieldIds: z.array(z.string().min(1).max(160)).max(200).optional(),
});
export const ClinicDocumentFillSuggestionsResponseSchema = z.strictObject({
    selectionId: z.uuid(),
    selectionHash: HashSchema,
    document: z.strictObject({
        documentId: z.uuid(),
        version: z.number().int().positive(),
        contentHash: HashSchema,
    }),
    sourceContextHash: HashSchema,
    inputHash: HashSchema,
    modelId: z.string().min(1).max(160),
    suggestions: z
        .array(z.strictObject({
        fieldId: z.string().min(1).max(160),
        status: z.enum(["suggested", "abstained"]),
        value: z.string().max(4_000).optional(),
        confidence: z.number().min(0).max(1),
        evidence: z
            .array(z.strictObject({
            sourceKey: z.string().min(1).max(240),
            description: z.string().min(1).max(400),
        }))
            .max(20),
        reason: z.string().min(1).max(500).optional(),
    }))
        .max(200),
});
//# sourceMappingURL=clinic-document-fill-suggestions.js.map